import { render, staticRenderFns } from "./LetsChat.vue?vue&type=template&id=f66c66d0&scoped=true"
import script from "./LetsChat.vue?vue&type=script&lang=js"
export * from "./LetsChat.vue?vue&type=script&lang=js"
import style0 from "./LetsChat.vue?vue&type=style&index=0&id=f66c66d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66c66d0",
  null
  
)

export default component.exports